import React from "react";
import styled from "styled-components";
import image1 from '../images/home/featuredProduct1.png';
import image2 from '../images/home/featuredProduct2.png';
import image3 from '../images/home/featuredProduct3.png';
import image4 from '../images/home/featuredProduct4.png';
import image5 from '../images/home/featuredProduct5.png';
import image6 from '../images/home/featuredProduct6.png';
import image7 from '../images/home/featuredProduct7.png';
import image8 from '../images/home/featuredProduct8.png';

const products = [
  {
    id: 1,
    title: "GTI Youth Short Sleeve T-Shirt - I Like My...",
    image: image1,
    price: "$15.00 USD",
  },
  {
    id: 2,
    title: "Noel Collection- Coconut Soy Candle",
    image: image2,
    price: "$20.00 USD",
    ribbon: "ARTIST-MADE",
  },
  {
    id: 3,
    title: "Free in Christ Unisex T-shirt",
    image: image3,
    fromPrice: "From $14.00 USD",
  },
  {
    id: 4,
    title: "Stone Cross Bracelet - Green",
    image: image4,
    oldPrice: "$9.97 USD",
    price: "$7.97 USD",
    discount: "-20% OFF",
  },
  {
    id: 5,
    title: "GTI Apron - Jesus Got the Wheel",
    image: image5,
    price: "$27.25 USD",
  },
  {
    id: 6,
    title: "Conversation Starters for Families Boxed Set",
    image: image6,
    price: "$9.99 USD",
    ribbon: "ARTIST-MADE",
  },
  {
    id: 7,
    title: "Love One Another Basic Pillow",
    image: image7,
    fromPrice: "From $22.95 USD",
  },
  {
    id: 8,
    title: "Faith Moves Mountains - Unisex Hoodie",
    image:image8,
    price: "$39.95 USD",
    discount: "-20% OFF",
  }
];

const FeaturedProducts = () => {
  return (
    <Wrapper>
      <Heading>Featured Products</Heading>

      <Grid>
        {products.map((item) => (
          <Card key={item.id}>
            <ImageBox>
              {item.ribbon && <Ribbon>{item.ribbon}</Ribbon>}
              <img src={item.image} alt={item.title} />
              {item.discount && <DiscountTag>{item.discount}</DiscountTag>}
            </ImageBox>

            <Title>{item.title}</Title>

            <PriceBox>
              {item.oldPrice && <OldPrice>{item.oldPrice}</OldPrice>}
              {item.fromPrice ? (
                <Price>{item.fromPrice}</Price>
              ) : (
                <Price>{item.price}</Price>
              )}
            </PriceBox>
          </Card>
        ))}
      </Grid>
    </Wrapper>
  );
};

export default FeaturedProducts;


const Wrapper = styled.section`
  padding: 50px 30px;
  background: #ede7e1; 
  text-align: center;
`;

const Heading = styled.h2`
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 40px;
  color: #2f3c37;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 25px;

  @media (max-width: 950px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 520px) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled.div`
  background: transparent;
  padding-bottom: 20px;
`;

const ImageBox = styled.div`
  background: white;
  border-radius: 20px;
  padding: 20px;
  height: 260px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
  }
`;

const Ribbon = styled.span`
  position: absolute;
  top: 10px;
  left: 10px;
  background: #1b6a71;
  color: white;
  padding: 5px 10px;
  font-size: 9px;
  font-weight: bold;
  border-radius: 5px;
`;

const DiscountTag = styled.span`
  position: absolute;
  bottom: 10px;
  left: 10px;
  background: red;
  color: white;
  padding: 5px 10px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 5px;
`;

const Title = styled.p`
  margin: 15px 0 5px;
  font-size: 12px;
  color: #3a3a3a;
`;

const PriceBox = styled.div`
  font-size: 16px;
  margin-top: 5px;
`;

const OldPrice = styled.span`
  text-decoration: line-through;
  color: #9b9b9b;
  margin-right: 8px;
`;

const Price = styled.span`
  color: #b52525;
  font-size: 16px;
  font-weight: bold;
`;
